<template>
  <svg width="947" height="299" viewBox="0 0 947 299" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin: 0 auto">
    <rect width="947" height="299" fill="white"></rect>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="47"
          font-weight="bold" letter-spacing="0.01em"><tspan x="736" y="212.18">{{ $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getDProcentData.d * 100) ? (getDProcentData.d === 'н.д.' ? 'н.д.': 'x'): getDProcentData.d * 100, 1, 'float', true,  'н.д.', '', (v) => v + '%') }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="47"
          letter-spacing="0.01em"><tspan x="30" y="211.833">df  =                                                =</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="23"
          letter-spacing="0.01em"><tspan x="75" y="217.897">is</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="21"
          letter-spacing="0.01em"><tspan x="166" y="158.819">Доля принятых на обучение за счет средств
</tspan>
      <tspan x="166" y="186.644">федерального бюджета по {{getDProcentData.sprKcpGroupId }} в {{getDProcentData.m }} году</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="21"
          letter-spacing="0.01em"><tspan x="166" y="248.819">100%, если по {{getDProcentData.sprKcpGroupId }} в {{getDProcentData.m }} году не было приема</tspan></text>
    <line x1="30" y1="100.5" x2="775" y2="100.5" stroke="#CFD8DC"></line>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="28" y="77.2402">
<tspan font-weight="600">{{getDProcentData.sprRegionName }}</tspan>, {{getDProcentData.sprKcpGroupSprUslName }}: {{ getDProcentData.sprKcpGroupId }} {{ getDProcentData.sprKcpGroupName }}
</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="22"
          letter-spacing="0.01em"><tspan x="30" y="43.68">Определение расчетной доли федерального бюджета в приеме
</tspan></text>
    <path
      d="M154 132L151.524 132C147.106 132 143.524 135.582 143.524 140L143.524 151.478M154 260H151.524C147.106 260 143.524 256.418 143.524 252L143.524 240.522M135.524 196L132 196M135.524 196C139.942 196 143.524 192.418 143.524 188L143.524 150.551M135.524 196C139.942 196 143.524 199.582 143.524 204L143.524 241.449"
      stroke="#263238" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>

</template>

<script>
import request from "@/services/request";
import {svgPropsMapper} from "@/mixins/svgPropsMapper";

export default {
  name: "Drf",
  mixins: [svgPropsMapper],
  props: {
    kcpGroupId: null,
    regionId: null,
  },
  data() {
    return {
      getDProcentData: {
        id: 0,
        sprKcpGroupId: "string",
        sprKcpGroupName: "string",
        sprKcpGroupSprUslName: "string",
        sprRegionId: "string",
        sprRegionName: "string",
        sprRegionNameGenitive: "string",
        dfb: 0,
        k1: 0,
        k2: 0,
        k3: 0,
        dpr: 0,
        k0: 0,
        d: 0,
        m: 0
      },
    }
  },
  async created() {
    await this.getD_Svg();
  },
  methods: {
    async getD_Svg() {
      try {
        const res = await request({
          endpoint: `/api/information/getDproc?kcpGroupId=${this.kcpGroupId}`,
          method: 'get',
        });
        if (res.status === 200 ) {
          console.log('getD_Svg успех');
          if (res.data) {
            this.mapServerData(res.data);
          }else
            this.mapServerData();
        }
        this.changeDefaultValues()
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;700');
@import url('https://fonts.googleapis.com/css2?family=PT+Serif');

text {
  font-feature-settings: 'pnum' on, 'lnum' on;
}
</style>